var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as RouterLink, } from 'react-router-dom';
import { C } from '#integrations';
import { LinkTestIdFactory } from './interactions';
import { LINK_KINDS } from './Link.constants';
import styles from './Link.module.css';
const KIND_CLASS_MAP = {
    standard: styles.Standard,
    subtle: styles.Subtle,
};
export const Link = ({ 'aria-current': ariaCurrent, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, children, className, 'data-test-state': testState, 'data-testid': testid, EndIcon, inheritFontStyles = false, isFullWidth = false, kind = LINK_KINDS.Standard, onClick, StartIcon, tabIndex, target, title, to, }) => {
    return (_jsxs(RouterLink, { "aria-current": ariaCurrent, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, className: C(styles.Container, KIND_CLASS_MAP[kind], className, inheritFontStyles &&
            kind === 'standard' &&
            styles.InheritFontStyles, isFullWidth && styles.FullWidth), "data-test-state": testState, "data-testid": LinkTestIdFactory.getLinkTestId(testid), onClick: onClick, tabIndex: tabIndex, target: target, title: title, to: to, children: [StartIcon && _jsx(StartIcon, { className: styles.Icon, size: "small" }), children, EndIcon && _jsx(EndIcon, { className: styles.Icon, size: "small" })] }));
};
_react_refresh_temp_1 = Link;
$RefreshReg$(_react_refresh_temp_1, "Link");
